module.exports = __webpack_public_path__ + "static/img/bgblue.4ab86ba1.png";